<template>
  <div>
    <vue-toastr ref="contentPreviewToast"></vue-toastr>
    <div v-if="!contentProp.url">
      <file-pond
          :server="server"
          name="image"
          ref="pond"
          label-idle="Hier klicken oder Bild reinziehen..."
          :allow-multiple="false"
          :accepted-file-types="acceptedFiles()"
          maxFileSize="10MB"
          @processfile="afterUpload"
          :disabled="disabled"
          @addfile="afterAddFile"
      />
    </div>
    <div v-else>
      <br>
      <div class="row" style="display: flex; align-items: center">
        <div class="col-md-1">
          <button class="btn btn-danger float-right" style="margin-top: 50%;" slot="browse-btn"
                  content="Bild entfernen"
                  @click="removeImage({index: index, type: contentProp.type})"
                  :disabled="disabled"
                  v-tippy><i class="fa fa-trash"></i>
          </button>
        </div>
        <div class="col-md-11">
          <div style="display: flex; justify-content: center;  background: #eeeeee; border-radius: 15px ">
            <video controls :src="contentProp.url"
                   v-if="contentProp.url.includes('.mov') || contentProp.url.includes('.mp4') || contentProp.url.includes('.webm')"
                   style="max-width: 100%; max-height: 300px"></video>
            <img :src="contentProp.url" style="max-width: 100%; max-height: 300px" v-else>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import vueFilePond, {setOptions} from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import de_DE from "filepond/locale/de-de"
import VueToastr from "vue-toastr";

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

setOptions(de_DE)

export default {
  name: 'ContentPreview',
  components: {FilePond, VueToastr},
  props: ['index', 'disabled', 'contentProp', 'minRatio', 'maxRatio', 'scaleWidth', 'scaleHeight'],
  data() {
    return {
      files: [],
      server: {
        url: '/api/content-hub/image/upload',
        process: {
          url: '',
          method: 'POST',
          withCredentials: true,
          headers: {},
          timeout: 60000,
          ondata: (formData) => {
            formData.append('id', this.record.id);
            formData.append('client_id', this.record.client_id)
            if (this.scaleWidth && this.scaleHeight) { //Autoscale image on upload via backend
              formData.append('scale_width', this.scaleWidth);
              formData.append('scale_height', this.scaleHeight);
            }
            return formData;
          },
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      'channels': 'getChannels',
      'mediaType': 'getMediaType',
      user: 'getUser',
      record: 'getRecord'
    })
  },
  methods: {
    acceptedFiles() {
      return 'image/jpeg, image/png, video/mov, video/mp4';
    },
    isVideo(url) {
      return (url.includes('.mov') || url.includes('.mp4'))
    },
    async afterAddFile(error, fileItem) {
      if (error || !fileItem?.file || !this.minRatio || !this.maxRatio) return;

      try {
        const file = fileItem.file;

        if (file.type.startsWith('image/')) {
          const img = new Image();

          await new Promise((resolve, reject) => {
            img.onload = () => {
              const actualRatio = img.width / img.height;
              const min = parseFloat(this.minRatio);
              const max = parseFloat(this.maxRatio);

              const isValid = actualRatio >= min && actualRatio <= max;

              if (!isValid) {
                this.$refs.pond.removeFile(fileItem.id);
                this.$refs.contentPreviewToast.e(
                    `Erlaubt sind Seitenverhältnisse zwischen ${this.minRatio} und ${this.maxRatio}.`,
                    'Fehler'
                );
                reject(new Error('Ungültiges Seitenverhältnis'));
              } else {
                resolve();
              }
            };

            img.onerror = () => reject(new Error('Bild konnte nicht geladen werden'));
            img.src = URL.createObjectURL(file);
          });
        }
      } catch (e) {
        console.error("Fehler bei der Ratio-Prüfung");
        this.$refs.pond.removeFile(fileItem.id);
      }
    },
    afterUpload(error, file) {
      const response = JSON.parse(file.serverId);
      if (['wordpress', 'shopware'].includes(this.channels[this.index].channel) && !this.isVideo(response.content_url)) {
        if (this.contentProp.type === 'content') {
          this.channels[this.index].news_content = `<img src="${response.content_url}"> ${this.channels[this.index].news_content}`
          this.channels[this.index].content_url = null;
        } else {
          this.channels[this.index].preview_image_url = response.content_url;
        }
        this.$refs.pond.value = null;
      } else {
        if (this.contentProp.type === 'content') {
          this.channels[this.index].content_url = response.content_url;
        } else {
          this.channels[this.index].preview_image_url = response.content_url;
        }
      }

      this.$emit('update:channels', this.channels)
    },
    triggerFileUploader() {
      document.getElementById("file").click()
    },
    ...mapMutations(['removeImage'])
  }
}
</script>

<style scoped>
</style>
<style>
.filepond--action-process-item, .filepond--credits {
  display: none !important;
}
</style>
